import { Component } from '@angular/core';

@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    template: `
    <span class="created-by">
      ©  <b><a href="https://customerinspire.com/" target="_blank">CustomerInspire</a></b> {{year}}
    </span>
    <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
    standalone: false
})
export class FooterComponent {
  year = new Date().getFullYear()
}
